var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_vm._t("default"),_vm._m(0)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container"},[_c('img',{attrs:{"src":require("@/assets/img/flightdeck-logo-inverse.png")}})])
}]

export { render, staticRenderFns }